import { create } from "zustand";
import { devtools } from "zustand/middleware";

export type PanelTab = "mcp-servers" | "suggestions" | "tasks";

type PanelState = {
  activeTab: PanelTab;
  isPanelOpen: boolean;
  setActiveTab: (tab: PanelTab) => void;
  togglePanel: () => void;
  openPanel: (tab: PanelTab) => void;
  closePanel: () => void;
};

export const usePanelStore = create<PanelState>()(
  devtools(
    (set) => ({
      activeTab: "suggestions",
      isPanelOpen: true,
      setActiveTab: (tab) =>
        set((state) => ({
          activeTab: tab,
          isPanelOpen: state.activeTab === tab ? !state.isPanelOpen : true,
        })),
      togglePanel: () =>
        set((state) => ({
          isPanelOpen: !state.isPanelOpen,
        })),
      openPanel: (tab) =>
        set({
          activeTab: tab,
          isPanelOpen: true,
        }),
      closePanel: () => set({ isPanelOpen: false }),
    }),
    { name: "panel-store" },
  ),
);
